import { displayNotif } from 'hb-react/shared/helpers/notifications';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const fetchDonations = (path) => async () => {
  try {
    const {
      data: { donations },
    } = await axios.get(path);

    return {
      donations,
    };
  } catch {
    displayNotif('error', __('Sorry, an error occurred'));
  }
};

export default fetchDonations;
